
export const Classes = {
    ERROR: "inErrorClass",
    MANDATORY: "isMandatory",
};

export const Types = {
    DATE: "date",
    EMAIL: "email",
    EMAIL_WITH_HANDLEBARS: "email-with-handlebars",
    HYPERLINK: "hyperlink",
    URL: "url",
    IP_ADDRESS_RANGE: "ip-address-range",
    IP_ADDRESS_RANGES: "ip-address-ranges",
    INTEGER: "integer",
    NUMBER_RANGE: "number-range",
    BIG_DECIMAL: "big-decimal",
    POSITIVE_NUMBER: "positive-number",
    MANDATORY: "mandatory",
    MANDATORY_EDJUSTER: "mandatory-edjuster",
    FILE_NAME: "file-name",
    WARNING: "warning", // generates a warning instead of failing validation
    HTML5: "html5", // perform HTML 5 input validation (reportValidity())
};
